module.exports = __webpack_public_path__ + "static/media/01.6c9927be.mp3";